import type { ContractDetails } from '@/api/schemas';
import { ContractStatusBadge } from '@/components/ContractStatusBadge';
import { Panel } from '@/components/ui/panel';
import { Separator } from '@/components/ui/separator';
import { VinLink } from '@/components/VinLink';
import type { ContractStatus } from '@/lib/contractStatus';
import { NOT_AVAILABLE, orNotAvailable } from '@/lib/display';
import { DateText } from '@/lib/formatDate';

function HeaderSeparator() {
  return <Separator orientation="vertical" className="h-4 bg-separator" />;
}

export function ContractHeader({
  contract,
  status,
}: {
  contract: ContractDetails;
  status: ContractStatus;
}) {
  const deliveryDate = contract.vehicle?.deliveryDate;

  return (
    <Panel variant="identity" size="wide">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="flex items-baseline gap-2">
          <span className="text-[20px] font-light uppercase leading-5 text-black">
            Contract
          </span>
          <h1 className="intl-headline-lg text-black">
            {contract.policyNumber}
          </h1>
        </div>
        <ContractStatusBadge status={status} />
      </div>

      <div className="mt-2 flex flex-wrap items-center gap-4 text-[16px] leading-5">
        <VinLink vin={contract.vin} variant="muted" />
        <HeaderSeparator />
        <span className="font-medium text-[var(--intl-accent)]">
          {orNotAvailable(contract.customerName)}
        </span>
        <HeaderSeparator />
        <span className="font-normal text-black">
          {orNotAvailable(contract.customerId)}
        </span>
        <HeaderSeparator />
        <span className="font-normal text-black">
          {orNotAvailable(contract.vehicle?.modelYear)}
        </span>
        <HeaderSeparator />
        <span className="flex items-center gap-2">
          <span className="font-normal text-black">DTU</span>
          <span className="font-medium text-black">
            {deliveryDate ? <DateText value={deliveryDate} /> : NOT_AVAILABLE}
          </span>
        </span>
      </div>
    </Panel>
  );
}
